import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getNativeSelectUtilityClasses(slot) {
  return generateUtilityClass('MuiNativeSelect', slot);
}
const nativeSelectClasses = generateUtilityClasses('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);
export default nativeSelectClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/NativeSelect/nativeSelectClasses.js
// module id = 164
// module chunks = 1